import { TextField } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import Compare from "../../../../../images/Compare.svg";
import Input from "../../../../../stories/Input/Input";
import { Title } from "../../../../../stories/Title/Title";
import {
  labelClasses,
  LabeledAutocomplete,
} from "../../../../../styles/AutocompleteStyles";
import {
  CustomModal,
  getModifiedScrollHeight,
  handleMUISelectEvent,
  toInputStandardDate,
  toIsoDate,
} from "../../../../../utils/UtilFunctions";
import { Keys } from "../../../../../utils/Enum.keys";
import { Button } from "../../../../../stories/Button/Button";
import { useNavigate } from "react-router-dom";
import { StyledDatagrid } from "../../../../../styles/DatagridStyles";
import { TableHeaderProps } from "../../../../../utils/types";
import {
  GridColDef,
  GridValidRowModel,
  GridAlignment,
  GridColumnVisibilityModel,
} from "@mui/x-data-grid-pro";
import useAssetTableJson from "../../../../../json/useAssetTableJson";
import {
  TABLE_ROW_HEIGHT,
  TOOLTIP_COLORS,
} from "../../../../../styles/Variables";
import { TooltipForMultipleOption } from "../../../../../styles/TooltipStyles";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import Add from "../../../../../images/Add.svg";
import MRFtoPo from "../../../../../images/PurchaseOrder.svg";
import Request from "../../../../../images/RequestForm.svg";
import Edit from "../../../../../images/EditProfile.svg";
import Delete from "../../../../../images/Delete.svg";
import DeleteModal from "../../../../../customComponents/DeleteModal";
import View from "./View";
import { ViewModalStyles } from "../../../../../styles/CustomModalStyles";
import { useLazyQuery } from "@apollo/client";
import {
  AtsPoMstEdge,
  AtsPoMstOrderField,
  GetPosResult,
  GetPosVar,
  PoQueryType,
} from "./queries/types";
import { GetPos } from "./queries/queries";

import { OrderDirection } from "../../../../../utils/commonQueryTypes";
import { AppContext } from "../../../../../context/context";
import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import { formDates } from "../material/ApprovedList";
import { LicenseTypes, Operation } from "../../../../../utils/Enum.types";
import {
  EMPTY_STRING,
  FETCH_MORE_DATA,
  emptyMessage,
} from "../../../../../utils/constants";
import LoadingModal from "../../../../pages/LoadingModal";
import MessageModal from "../../../../../customComponents/MessageModal";
import { ColumnVisibilityFor } from "../../../../../utils/Enum.Datagrid";
import Navbar from "../../../../common/layout/Navbar";
const Data = [
  {
    date: "12-03-2024",
    order_no: "34567",
    order_to_supplier: "fg",
    po_form: "MRF",
  },
  {
    date: "12-03-2024",
    order_no: "34567",
    order_to_supplier: "fg",
    po_form: "RFQ",
  },
];

const PurchaseOrderList = () => {
  const { Purchase } = useAssetTableJson();
  const { customer_id,company_id } = useUrlParams();
  const { state } = useContext(AppContext);
  
  const { data: todaysDateData, serverDate } = useServerDateandTime();

  const [dates, setDates] = useState<formDates>({
    startDate: "",
    endDate: "",
  });

  const [viewModal, setViewModal] = useState(false);
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [message, setMessage] = useState(emptyMessage);
  const [searchData, setSearchData] = useState(EMPTY_STRING);
  const [filterStatus, setFilterStatus] = useState(PoQueryType.ALL);
  const [endCursor, setEndCursor] = useState<string | null>(null);
  const [hasNextPage, setHasNextPage] = useState<boolean>(true);
  const [poMsts, setPoMsts] = useState<AtsPoMstEdge[]>([]);
  const [rows, setRows] = useState<GridValidRowModel[]>([]);

  const statusOptions = Object.values(PoQueryType);

  const [getPos, { data, loading, fetchMore }] = useLazyQuery<
    GetPosResult,
    GetPosVar
  >(GetPos);

  const formatText = (input: string) => {
    return input
      .replace(/_/g, " ") // Replace underscores with spaces
      .replace("/\bw/g", (char) => char.toUpperCase()); // Capitalize the first letter of each word
  };

  const dynamicHeaders: TableHeaderProps[] = Purchase.PurchaseOrder.List.map(
    (header) => ({
      headerName: header.headerName,
      field: header.field,
      headerAlign: header.headerAlign as GridAlignment,
      align: header.align as GridAlignment,
      flex: header.flex,
      hideable: header.hideable,
      cellClassName: header.cellClassName,
      renderCell: (params) => {
        if (header.field === "actions") {
          return (
            <>
              <img src={Edit} alt="" />
              <img
                src={Delete}
                alt=""
                onClick={() => setDeleteModal(!deleteModal)}
              />
            </>
          );
        } else if (header.field === "po_form") {
          return (
            <div
              className={params.row.po_form === "MRF" ? "bg-var" : "bg-amber"}
            >
              {params.row.po_form}
            </div>
          );
        }

        return params.value;
      },
    })
  );

  const columns: GridColDef[] = [...dynamicHeaders];
  const rows1: GridValidRowModel[] =
    (Data || []).map((data, index) => {
      return {
        id: index + 1,
        po_date: data.date,
        po_no: data.order_no,
        order_to_supplier: data.order_to_supplier,
        total_items_ordered: 0,
        total_qty_ordered: 0,
        net_total: 0,
        remarks: 0,
        po_form: data.po_form,
      };
    }) || [];

  useEffect(() => {
    const scrollTable = document.getElementsByClassName(
      "MuiDataGrid-virtualScroller"
    )[0] as Element;
    const handleScroll = (e: Event) => {
      const target = e.target as HTMLDivElement;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;
      if (scrollTop + clientHeight >= getModifiedScrollHeight(scrollHeight)) {
        if (hasNextPage && !loading) {
          fetchMore({
            variables: {
              first: FETCH_MORE_DATA,
              after: endCursor,
            },
            updateQuery: (prevResult, { fetchMoreResult }) => {
              if (!fetchMoreResult) return prevResult;

              const newEdges = fetchMoreResult.GetPos.edges;
              const pageInfo = fetchMoreResult.GetPos.pageInfo;
              setEndCursor(pageInfo.endCursor);
              setHasNextPage(pageInfo.hasNextPage);

              const duplicateCheck = prevResult.GetPos.edges.filter(
                ({ node: { id } }) =>
                  newEdges.findIndex(
                    ({ node: { id: newId } }) => newId === id
                  ) !== -1
              );

              if (duplicateCheck.length > 0) return prevResult;

              return {
                GetPos: {
                  edges: [...poMsts, ...newEdges],
                  pageInfo,
                  totalCount: data ? data.GetPos.totalCount! : 0,
                },
              };
            },
          });
        }
      }
    };
    if (scrollTable) scrollTable.addEventListener("scroll", handleScroll);

    return () => {
      if (scrollTable) scrollTable.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (data && !loading) {
      const newData = data.GetPos.edges;

      if (endCursor) {
        const updatedNewData = newData.map((newCompany) => {
          const filteredStudent = poMsts.find(
            (employee) => employee.node.id === newCompany.node.id
          );
          if (filteredStudent) {
            return {
              ...newCompany,
              node: {
                ...newCompany.node,
              },
            };
          }
          return newCompany;
        });
        setPoMsts(updatedNewData);

        setRows(
          updatedNewData.map(({ node }, index) => ({
            id: index + 1,
            po_date: node.poDate,
            po_no: node.poNo,
            order_to_supplier: node.ldgr.desc,
            total_items_ordered: node.itemQty,
            total_qty_ordered: node.totalQty,
            net_total: node.totalValue,
            remarks: node.remarks,
            po_form: "RFQ",
          }))
        );
      } else {
        setPoMsts(newData);

        setRows(
          newData.map(({ node }, index) => ({
            id: index + 1,
            po_date: node.poDate,
            po_no: node.poNo,
            order_to_supplier: node.ldgr.desc,
            total_items_ordered: node.itemQty,
            total_qty_ordered: node.totalQty,
            net_total: node.totalValue,
            remarks: node.remarks,
            po_form: "RFQ",
          }))
        );
      }
      setEndCursor(data.GetPos.pageInfo.endCursor);
    }
    // eslint-disable-next-line
  }, [data, loading]);

  useEffect(() => {
    if (customer_id && state.ActiveFinYr) {
      getPos({
        variables: {
          
          after: null,
          customerId: customer_id,
          finYrId: state.ActiveFinYr.id,
          queryType: filterStatus,
          start_date: toIsoDate(dates.startDate),
          end_date: toIsoDate(dates.endDate),
          orderBy: {
            direction: OrderDirection.ASC,
            field: AtsPoMstOrderField.PO_NO,
          },
          name: searchData,
        },
      });
    }
  }, [
    getPos,
    customer_id,
    searchData,
    dates,
    filterStatus,
    dates,
    state.ActiveFinYr,
  ]);

  useEffect(() => {
    if (todaysDateData && serverDate) {
      const getMonth = new Date(serverDate).getMonth();
      const getYear = new Date(serverDate).getFullYear();

      const firstDay = new Date(getYear, getMonth, 1); // First day of the month
      const lastDay = new Date(getYear, getMonth + 1, 0);

      setDates({
        endDate: lastDay.toString(),
        startDate: firstDay.toString(),
      });
    }
  }, [todaysDateData, serverDate]);

  const [columnVisibilityModel, setColumnVisibilityModel] =
    useState<GridColumnVisibilityModel>({});

  useEffect(() => {
    const savedModel = localStorage.getItem(ColumnVisibilityFor.PURCHASE_ORDER);
    if (savedModel) {
      setColumnVisibilityModel(JSON.parse(savedModel));
    }
  }, []);

  const handleColumnVisibilityChange = (
    newModel: GridColumnVisibilityModel
  ) => {
    setColumnVisibilityModel(newModel);
    localStorage.setItem(
      ColumnVisibilityFor.PURCHASE_ORDER,
      JSON.stringify(newModel)
    );
  };
  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} />
      <Title>Purchase Order</Title>
      <div className="purchase-order">
        <div className="purchase-order__select row g-0">
          <div className="col-2">
            <Input
              id="data_search"
              placeholder="Search..."
              onChange={(e) => setSearchData(e.target.value)}
            />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              options={statusOptions}
              getOptionLabel={(option) => {
                return formatText(option as string);
              }}
              value={filterStatus}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              onChange={(event, newValue) =>
                setFilterStatus(newValue as PoQueryType)
              }
              openOnFocus
              forcePopupIcon
              freeSolo
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="PO Form"
                  slotProps={{
                    inputLabel: {
                      shrink: true,
                    },
                  }}
                />
              )}
            />
          </div>
          <div className="col purchase-order__select--flex">
            <TextField
              className="purchase-order__select--textfield"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              label="Start Date"
              type="date"
              value={toInputStandardDate(dates.startDate)}
              onChange={(e) => {
                setDates({
                  ...dates,
                  startDate: e.target.value,
                });
              }}
            />
            <img
              src={Compare}
              alt=""
              className="purchase-order__select--compare"
            />
            <TextField
              className="purchase-order__select--textfield"
              slotProps={{
                inputLabel: {
                  shrink: true,
                },
              }}
              label="End Date"
              type="date"
              value={toInputStandardDate(dates.endDate)}
              onChange={(e) => {
                setDates({
                  ...dates,
                  endDate: e.target.value,
                });
              }}
            />
            <TooltipForMultipleOption
              title={
                <ul className="purchase-order__select--li">
                  <li
                    onClick={() =>
                      navigate(
                        `/${customer_id}/company/${company_id}/purchase/purchaseorder/mrftopo`
                      )
                    }
                  >
                    <img src={MRFtoPo} alt="" />
                    Material Request to PO
                  </li>
                  <li
                    onClick={() =>
                      navigate(
                        `/${customer_id}/company/${company_id}/purchase/purchaseorder/rfqtopo`
                      )
                    }
                  >
                    <img src={Request} alt="" />
                    Request Form Quotation to PO
                  </li>
                </ul>
              }
              placement="bottom"
              slotProps={{
                tooltip: {
                  sx: {
                    bgcolor: TOOLTIP_COLORS.GREY,
                    "& .MuiTooltip-arrow": {
                      color: TOOLTIP_COLORS.GREY,
                    },
                  },
                },
              }}
            >
              <span className="purchase-order__select--addnew">
                <img src={Add} alt="" />
                Add New
              </span>
            </TooltipForMultipleOption>
          </div>
        </div>
        <div className="purchase-order__tableblock">
          <StyledDatagrid
            columns={columns}
            rows={rows}
            rowHeight={TABLE_ROW_HEIGHT}
            onCellClick={(params) => {
              if (params.field === "po_no") {
                setViewModal(!viewModal);
              }
            }}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={handleColumnVisibilityChange}
            initialState={{
              columns: {
                columnVisibilityModel: columnVisibilityModel,
              },
            }}
            disableRowSelectionOnClick
            hideFooter
          />
        </div>
        <div className="purchase-order__buttons row g-0">
          <div className="col"></div>
          <div className="col flex-end"></div>
        </div>
        <Button mode="back" onClick={() => navigate(-1)} />
      </div>

      <DeleteModal
        id={0}
        modalFlag={deleteModal}
        setModalFlag={setDeleteModal}
        handleDelete={() => setDeleteModal(!deleteModal)}
      />

      <CustomModal
        isOpen={viewModal}
        onRequestClose={() => setViewModal(false)}
        contentComponent={
          <>
            <View setModalFlag={setViewModal} />
          </>
        }
        style={ViewModalStyles}
      />

      <MessageModal
        handleClose={() => setMessage(emptyMessage)}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />

      <LoadingModal flag={(!searchData && loading)} />
    </>
  );
};

export default PurchaseOrderList;
